import db from '../../Utilities/Firebase';

//category, theme, program, year, company, range number price
const filters = ['CATÉGORIE', 'THÉME', 'ÉMISSION', 'ANNÉE', 'COMPAGNIE', 'TRANCHE NOMBRE PRIX'];

export default async function GetData(yearFilter, rangeFilter, themeFilter) {
    
  let data = [], filteredData = [];
  
  //If data already exists in session storage, do not call from firebase
  const Data = sessionStorage.getItem('data'); 
  if(Data) {
    console.log('Session storage');
    const companyData = JSON.parse(Data);
    companyData.map(val => {
      if(yearFilter[val[filters[3]]] === true && 
        rangeFilter[val[filters[5]]] === true &&
        themeFilter[val[filters[1]]] === true) {
          filteredData.push(val);
      }
    });

    const response = {
      status: 'success',
      data: filteredData
    }

    return response;

  }

  function getDataFromFirebase() {
    console.log('Firebase');
    return db.collection('data')
    .get()
    .then((snapshot) => {
      snapshot.docs.map(doc => {
        // console.log(doc.data())
        data.push(doc.data());
      })
    });
  }

  return getDataFromFirebase()
  .then(() => {
    sessionStorage.setItem('data', JSON.stringify(data));
    data.map(val => {
      if(yearFilter[val[filters[3]]] === true && 
        rangeFilter[val[filters[5]]] === true &&
        themeFilter[val[filters[1]]] === true) {
          filteredData.push(val);
      }
    })
  })
  .then(() => {
    const response = {
      status: 'success',
      data: filteredData
    }

    return response;
  })
  .catch(error => {
    console.log('error', error);
    const response = {
      status: 'error', 
      error: error
    }

    return response;
  });

}